import { trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

export const REMOVE_TOP_HERO_BANNER_TEST_NAME = 'HP_NoTopBanner_Feb2026';

export const trackRemoveTopHeroBannerTest = (): void => {
    trackAbTestV2Variant(REMOVE_TOP_HERO_BANNER_TEST_NAME);
};
